import { goalsArchivedSectionID, goalsCompletedSectionID } from '@griply/types';

export const COMPLETED_SECTION_ID = goalsCompletedSectionID;
export const ARCHIVED_SECTION_ID = goalsArchivedSectionID;
